import axios from "axios";

export interface AnalyticsSummary {
  schema_version: 1;
  filters: {
    from: string;
    to: string;
    source: string | null;
    medium: string | null;
    campaign: string | null;
  };
  sessions: number;
  events: number;
  estimated_visitors: null;
  event_counts: Record<string, number>;
  sessions_by_day: Array<{ date: string; sessions: number }>;
  by_source: Array<{ source: string; sessions: number }>;
  by_campaign: Array<{ campaign: string; sessions: number }>;
  by_device_class: Array<{ device_class: "mobile" | "desktop" | "unknown"; sessions: number }>;
  matrix: Array<{ source: string; place_id: string; action: string; events: number }>;
}

const apiBase = process.env.REACT_APP_API_HOST ?? "";
const apiTimeout = 30000;

export async function getAnalyticsSummary(filters: {
  from: string;
  to: string;
  source?: string;
  medium?: string;
  campaign?: string;
}): Promise<AnalyticsSummary> {
  const response = await axios.get<AnalyticsSummary>(`${apiBase}/api/v1/analytics/summary`, {
    params: filters,
    timeout: apiTimeout,
  });
  return response.data;
}

export async function downloadAnalyticsQr(url: string): Promise<Blob> {
  const response = await axios.get(`${apiBase}/api/v1/analytics/qr`, {
    params: { url },
    responseType: "blob",
    timeout: apiTimeout,
  });
  return response.data;
}
